<template>
    <div>
        <!-- 轮播图 -->
        <div class="header">
            <div class="header-tag">Solution</div>
            <div class="header-title">解决方案</div>
        </div>
        <div class="m-30">
            <div class="w">
                <div class="cont1">
                    <p>
                        凡己科技致力于中低压、大电流类交流电机控制器、智能终端和远程管理系统等产品的研发与销售。主要有:交流电机控制器、智能仪表、远程监控管理系统等系列产品，广泛应用于电动叉车、电动仓储车、电动观光车、高尔夫球车、环卫车、高空作业平台等非道路电动车辆领域。
                    </p>
                    <p>公司坚持自主研发，对所有产品拥有完整知识产权，为非道路领域整机企业提供电动控制、智能、网联整体解决方案。</p>
                </div>
                <div>
                    <div class="flex-row flex-wrap ">
                        <!-- <div class="img-item" @click="select(index)" :class="{ 'img-active': index == selectIndex }" v-for="(item, index) in controllerData">

                            <img  :src="require('../../assets/img/icons/' + ((index == selectIndex)?item.imgselect:item.img))" style="width: 120px;" alt="">
                            <div class="img-select">
                                <div style="font-size: 18px;font-weight: 700;">{{item.name}}</div>
                                <div style="margin-top: 5px;"></div>
                            </div>
                        </div> -->
                        <div class="img-item" @click="select(index)" :class="{ 'img-active': index == selectIndex }"
                            v-for="(item, index) in industryData">


                            <img :src="http.ipAddress+item.industry.filePathSelected"
                                style="width: 120px;" alt=""  v-if="index == selectIndex">

                            <img :src="http.ipAddress+item.industry.filePath"
                                style="width: 120px;" alt=""  v-else>

                            <!-- <img  :src="require('../../assets/img/icons/' + ((index == selectIndex)?item.imgselect:item.img))" style="width: 120px;" alt=""> -->
                            <div class="img-select">
                                <div style="font-size: 18px;font-weight: 700;">{{item.industry.industryName}}</div>
                                <div style="margin-top: 5px;">{{item.industry.industryNameEN}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div  >
                        <!-- <img  src="../../assets/img/仓储车辆.jpg" style="width: 100%;margin-bottom: 30px;" alt=""> -->
                        <!-- <img :src="controllerData[selectIndex].path" style="width: 100%;margin-bottom: 30px;" alt=""> -->
                        <img :src="http.ipAddress+bannerFilePath" style="width: 100%;margin-bottom: 30px;" alt="">
                        <!-- <img v-if="selectIndex == 0" src="../../assets/img/仓储车辆.jpg" style="width: 100%;margin-bottom: 30px;" alt="">
                        <img v-if="selectIndex == 1" src="../../assets/img/工程机械.jpg" style="width: 100%;margin-bottom: 30px;" alt="">
                        <img v-if="selectIndex == 2" src="../../assets/img/观光车.jpg" style="width: 100%;margin-bottom: 30px;" alt="">
                        <img v-if="selectIndex == 3" src="../../assets/img/割草机.jpg" style="width: 100%;margin-bottom: 30px;" alt="">
                        <img v-if="selectIndex == 4" src="../../assets/img/高尔夫球车.jpg" style="width: 100%;margin-bottom: 30px;" alt="">
                        <img v-if="selectIndex == 5" src="../../assets/img/环卫车.jpg" style="width: 100%;margin-bottom: 30px;" alt="">
                        <img v-if="selectIndex == 6" src="../../assets/img/农机.jpg" style="width: 100%;margin-bottom: 30px;" alt="">
                        <img v-if="selectIndex == 7" src="../../assets/img/船舶.jpg" style="width: 100%;margin-bottom: 30px;" alt="">
                        <img v-if="selectIndex == 8" src="../../assets/img/叉车.jpg" style="width: 100%;margin-bottom: 30px;" alt=""> -->
                    </div>
                    <div class="flex-row flex-wrap ">
                        <!-- <div @click="page(item.switch,item.index)"  class="products-item flex-column align-center justify-center" :class="{ 'active': index == 0 }"
                            v-for="(item, index) in controllerData[selectIndex].schemeData">
                            <img  :src="require('../../assets/img/controller/' + item.img)" style="width: 300px;height: 300px;" alt="">
                            <div class="item-name">{{item.nmae}}</div>
                        </div> -->
                        <div  class="products-item flex-column align-center justify-center" :class="{ 'active': index == 0 }"
                            v-for="(item, index) in industryData[selectIndex].productInfos">
                            <img :src="http.ipAddress+item.filePath"
                            style="width: 300px;height: 300px;" alt="" @click="page(item.productType,item.id)" >
                            <div class="item-name">{{item.productName}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

export default {
    data() {
        return {
            selectIndex: 0,
            industryData:[

            ],
            bannerFilePath:"",
            controllerData:[
                {
                    name:"叉车",
                    imgselect:"icons_1.png",
                    img:"icons_1_1.png",
                    path:require("../../assets/img/叉车.jpg"),
                        schemeData:[
                            {
                                nmae:"D1M+D1S总成",
                                img:"叉车-1-合力总成 D1M+D1S-3-3.5吨电控总成.png",
                                path:"",
                                index:"0",
                                switch:1
                            },{
                                nmae:" G2油改电总成",
                                img:"叉车-2 龙工g2-80v-3-3.5吨点控总成.png",
                                path:"",
                                index:"2",
                                switch:1
                            },{
                                nmae:"D1M+D1L总成",
                                img:"叉车-4-FJ D1M + FJ D1L 3 35吨电控总成.png",
                                path:"",
                                index:"0",
                                switch:1
                            },{
                                nmae:"S2+G1三支点总成",
                                img:"叉车-5-G1S2 2.5吨双驱三支点.png",
                                path:"",
                                index:"1",
                                switch:1
                            },
                            
                        ]
                },
                {
                    name:"高空作业平台",
                    imgselect:"icons_2.png",
                    img:"icons_2_1.png",
                    path:require("../../assets/img/高空作业平台.jpg"),
                        schemeData:[
                            {
                                nmae:"G2 80V 高机总成",
                                img:"叉车-2 龙工g2-80v-3-3.5吨点控总成.png",
                                path:"",
                                index:"2",
                                switch:1
                            },
                            // {
                            //     nmae:"FJ-S1系列电动车辆控制系统",
                            //     img:"S1.png",
                            //     path:"",
                            //     index:"6",
                            //     switch:1
                            // },
                            // {
                            //     nmae:"FJ-S1X系列电动车辆控制系统",
                            //     img:"S1X.png",
                            //     path:"",
                            //     index:"5",
                            //     switch:1
                            // },
                            {
                                nmae:"S1M 80V 五交总成",
                                img:"高空-9 FJ S1M25-28米曲臂式高空作业车点控总成.png",
                                path:"",
                                index:"6",
                                switch:1
                            },{
                                nmae:"S1M 80V 五交总成",
                                img:"叉车-10- fjzc-s1-l_m-001-xg-80v-03 已拆件.61.png",
                                path:"",
                                index:"6",
                                switch:1
                            },
                            {
                                nmae:" S1X高机方案",
                                img:"高空-11- S1X6-16米剪叉式高空作业平台电控及仪表方案.png",
                                path:"",
                                index:"5",
                                switch:1
                            }
                        ]
                    
                    
                },
                {
                    name:"高尔夫球车、观光车",
                    imgselect:"icons_3.png",
                    img:"icons_3_1.png",
                    path:require("../../assets/img/观光车.jpg" ),
                        schemeData:[
                            // {
                            //     nmae:"FJ-S1系列电动车辆控制系统",
                            //     img:"S1.png",
                            //     path:"",
                            //     index:"6",
                            //     switch:1
                            // },{
                            //     nmae:"FJ-G1系列电动车辆控制系统",
                            //     img:"G1.png",
                            //     path:"",
                            //     index:"1",
                            //     switch:1
                            // },
                            {
                                nmae:"S1S总成",
                                img:"球车-6-S1S高尔夫球车电控总成.png",
                                path:"",
                                index:"6",
                                switch:1
                            },{
                                nmae:"G1内置接触器单控总成",
                                img:"球车-7-G1 高尔夫球车点控总成.png",
                                path:"",
                                index:"1",
                                switch:1
                            },{
                                nmae:"S1L总成",
                                img:"球车-12-朗晴.jpg",
                                path:"",
                                index:"6",
                                switch:1
                            }
                        ]
                },
                {
                    name:"割草机",
                    imgselect:"icons_4.png",
                    img:"icons_4_1.png",
                    path:require("../../assets/img/割草机.jpg"),
                        schemeData:[
                            {
                                nmae:"FJ-S0系列电动车辆控制系统",
                                img:"S0.png",
                                path:"",
                                index:"3",
                                switch:1
                            },{
                                nmae:"FJ-S1系列电动车辆控制系统",
                                img:"S1.png",
                                path:"",
                                index:"6",
                                switch:1
                            }
                        ]
                },
                {
                    name:"仓储车",
                    imgselect:"icons_5.png",
                    img:"icons_5_1.png",
                    path:require("../../assets/img/仓储车辆.jpg"),
                        schemeData:[
                        // {
                        //         nmae:"D1M+D1S总成",
                        //         img:"叉车-1-合力总成 D1M+D1S-3-3.5吨电控总成.png",
                        //         path:"",
                        //         index:"0",
                        //         switch:1
                        //     },{
                        //         nmae:" G2油改电总成",
                        //         img:"叉车-2 龙工g2-80v-3-3.5吨点控总成.png",
                        //         path:"",
                        //         index:"2",
                        //         switch:1
                        //     },{
                        //         nmae:"D1M+D1L总成",
                        //         img:"叉车-4-FJ D1M + FJ D1L 3 35吨电控总成.png",
                        //         path:"",
                        //         index:"0",
                        //         switch:1
                        //     },{
                        //         nmae:"S2+G1三支点总成",
                        //         img:"叉车-5-G1S2 2.5吨双驱三支点.png",
                        //         path:"",
                        //         index:"1",
                        //         switch:1
                        //     },
                            {
                                nmae:"FJ-S1X系列电动车辆控制系统",
                                img:"S1X.png",
                                path:"",
                                index:"5",
                                switch:1
                            },{
                                nmae:"FJ-S0系列电动车辆控制系统",
                                img:"S0.png",
                                path:"",
                                index:"3",
                                switch:1
                            },{
                                nmae:"FJ-MS",
                                img:"MS.png",
                                path:"",
                                index:"3",
                                switch:2
                            }
                        ]
                },
                {
                    name:"环卫车、牵引车",
                    imgselect:"icons_6.png",
                    img:"icons_6_1.png",
                    path:require("../../assets/img/环卫车.jpg"),
                        schemeData:[
                            {
                                nmae:"G2 总成",
                                img:"叉车-2 龙工g2-80v-3-3.5吨点控总成.png",
                                path:"",
                                index:"2",
                                switch:1
                            },
                            {
                                nmae:"G1 内置接触器单控总成",
                                img:"球车-7-G1 高尔夫球车点控总成.png",
                                path:"",
                                index:"1",
                                switch:1
                            },
                            // {
                            //     nmae:"FJ-S1系列电动车辆控制系统",
                            //     img:"S1.png",
                            //     path:"",
                            //     index:"6",
                            //     switch:1
                            // },
                            {
                                nmae:"S1总成",
                                img:"牵引车-8-合力S1-48V牵引车 DB20车型.png",
                                path:"",
                                index:"6",
                                switch:1
                            }
                        ]
                },
                {
                    name:"农机",
                    imgselect:"icons_7.png",
                    img:"icons_7_1.png",
                    path:require("../../assets/img/农机.jpg"),
                        schemeData:[
                            {
                                nmae:"FJ-S1系列电动车辆控制系统",
                                img:"S1.png",
                                path:"",
                                index:"6",
                                switch:1
                            }
                        ]
                },
                {
                    name:"船舶",
                    imgselect:"icons_8.png",
                    img:"icons_8_1.png",
                    path:require("../../assets/img/船舶.jpg"),
                        schemeData:[
                            {
                                nmae:"FJ-S1系列电动车辆控制系统",
                                img:"S1.png",
                                path:"",
                                index:"6",
                                switch:1
                            }
                        ]
                },
                // {
                //     name:"叉车",
                //     imgselect:"icons_9.png",
                //     img:"icons_9_1.png",
                //     path:require("../../assets/img/叉车.jpg"),
                //         schemeData:[
                //             {
                //                 nmae:"FJ-D1系列电动车辆控制系统",
                //                 img:"D1.png",
                //                 path:"",
                //                 index:"0"
                //             },{
                //                 nmae:"FJ-S2系列电动车辆控制系统",
                //                 img:"S2.png",
                //                 path:"",
                //                 index:"7"
                //             },{
                //                 nmae:"FJ-G2系列电动车辆控制系统",
                //                 img:"G2.png",
                //                 path:"",
                //                 index:"2"
                //             }
                //         ]
                // }
            ],
           
        }
    },
    methods: {
        select(index) {
            this.selectIndex = index
            this.bannerFilePath=this.industryData[index].industry.industryBanner;
            this.$store.commit('setSolutionIndustry', index);
        },
        page(switchValue,index) {
            debugger
            if(switchValue==3){
                this.$router.push({path:'/productAssembly', query: {index}});
            }else{
                this.$router.push({path:'/productsDetail', query: {switch:switchValue,index}});
            }
           
        },
        // page1(index) {
        //     this.$router.push({path:'/productsDetail', query: {switch:2,index}});
        // }
    

    },
    mounted() {
            debugger
            let that=this;
            this.http.post("/api/FJ_Industry/GetAllIndustry",JSON.stringify({})).then((result)=>{
                debugger
            let objResult= eval(result);
            let iCode= objResult.code;
            if(iCode==0){
                debugger
                that.selectIndex=that.$store.getters.getSolutionIndustry();
                    that.industryData=objResult.data;
                    if(that.industryData.length>0){
                        that.bannerFilePath=that.industryData[that.selectIndex].industry.industryBanner;
                    }
                }
            });
        }
}
</script>
<style scoped>
.header {
    background: url('../../assets/img/solutionbanner.jpg') no-repeat;
    background-size: 100%;
}

.products-item {
    width: 33%;
    padding: 30px;
    box-sizing: border-box;
    border: 1px solid #eee;
    margin-bottom: 30px;
    border: 1px solid transparent;
}

.products-item:hover {
    border: 1px solid #0AA00A;
}

.m-30 {
    margin: 30px 0;
}

.cont1 p {
    text-indent: 2rem;
    margin-bottom: 20px;
    line-height: 30px;
}

.a-item {
    width: 33.3%;
}

.a-img {
    padding: 10rpx;
    border: 1px solid #eee;
    margin: 20px;
}

.img-item {
    position: relative;
    padding-bottom: 120px;
}

.img-select {
    display: none;
    position: absolute;
    margin-top: 20px;
    padding-top: 20px;
    width: 200px;
    border-top: 1px solid #0AA00A;
}

.img-select::after {
    content: '';
    position: absolute;
    top: -10px;
    left: 30px;
    display: none;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #0AA00A;
    cursor: pointer;
}

.img-active .img-select {
    display: block;
}

.img-active .img-select::after {
    display: flex;
}
</style>


// WEBPACK FOOTER //
// src/views/scheme/index.vue